import {Injectable} from '@angular/core';

/**
 * Simple Angular EventService
 * by Lars Krämer - lkraemer.de
 *
 * view on GitHub: https://github.com/lk-code/angular-simple-event-service
 *
 * ##################################################################################
 *
 * MIT License
 *
 * Copyright (c) 2019 Lars Krämer
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
@Injectable({
    providedIn: 'root'
})
export class EventService {
    private events: { name: string, handler: Function }[] = [];
    
    constructor() {
    
    }
    
    /**
     * adds an listen-method to the given event-key
     *
     * @param name the event name to subscribe
     * @param handler the method which should be executed
     */
    public Subscribe(name: string, handler: Function) {
        this.events.push({name, handler});
    }
    
    /**
     * triggers an event by the given name and gives the data to the listening method
     *
     * @param name the name of the event to trigger
     * @param data the data for the triggered event
     */
    public Trigger(name: string, data?: any) {
        const requestedEvents = this.events.filter(e => e.name === name);
        
        for (const requestedEvent of requestedEvents) {
            requestedEvent.handler(data);
        }
    }
}
